module.exports = __webpack_public_path__ + "static/media/16UNODC19.54d288a2.jpg";